const freeadvtests = [
  { id: 2024, title: "JEE Advanced 2024, Paper 1 - Full Paper", subject: "Physics | Chemistry | Mathematics", duration: "180 Minutes", route: "/test-series/pyq/jeeadv/test1" },
  
];

export default freeadvtests;